export const DEBI_CREATE_FORM = [
  {
    label: "Business Name",
    key: "businessName",
    type: "text",
  },
  {
    label: "Telephone",
    key: "telephone",
    type: "text",
  },
  {
    label: "Street Address",
    key: "installerStreetAddress",
    type: "text",
  },
  {
    label: "Installer Email",
    key: "installerEmail",
    type: "text",
  },
  {
    label: "City",
    key: "installerCity",
    type: "text",
  },
  {
    label: "State",
    key: "installerState",
    type: "text",
  },
  {
    label: "Zip Code",
    key: "zipCode",
    type: "text",
  },
];

export const DEBI_NEW_FORM = [
  {
    label: "Distribution Center",
    key: "disCenter",
    type: "text",
    icon: "search",
  },
  {
    label: "Store",
    key: "store",
    type: "text",
    icon: "search",
  },
  {
    label: "Dealer Number",
    key: "dealerNum",
    type: "text",
  },
  {
    label: "Business Name",
    key: "bName",
    type: "text",
  },
  {
    label: "Telephone",
    key: "tel",
    type: "text",
  },
  {
    label: "Street Address",
    key: "streetAddress",
    type: "text",
  },
  {
    label: "Installer Email",
    key: "installerEmail",
    type: "text",
  },
  {
    label: "City",
    key: "city",
    type: "text",
  },
  {
    label: "State",
    key: "state",
    type: "text",
  },
  {
    label: "Zip Code",
    key: "zipcode",
    type: "text",
  },
];

export const AGREEMENT_INPUT_FORM = {
  label: "Name of Installer Contact",
  key: "installerBusinessName",
  type: "text",
  // readOnly: false,
};
export const STATUS={
  OPEN: "Open",
  IN_PROGRESS: "In Progress",
  CLOSED:"Closed",
  INCOMPLETE: "Incomplete"
}
export const PROCESSING_INFO = {
  label: "Sales Rep",
  key: "salesRep",
  type: "text",
  readOnly: true,
};

export const SIGNATURES_STORE_INPUT_FORM = [
  {
    label: "Store Manager/Owner",
    key: "storeAgent",
    type: "text",
  },
  {
    label: "Store Manager/Owner Email",
    key: "storeAgentEmail",
    type: "text",
  },
];

export const SIGNATURES_DC_INPUT_FORM = [
  {
    label: "District Manager/DC Sales Manager",
    key: "dcName",
    type: "text",
  },
  {
    label: "District Manager/DC Sales Manager Email",
    key: "dcEmail",
    type: "text",
  },
];

export const DEBI_DETAILS = [
  {
    label: "DEBI Registration #",
    key: "debiRegistrationNumber",
    type: "text",
  },
  {
    label: "Status Reason",
    key: "statusReason",
    type: "text",
  },
  {
    label: "Form Type",
    key: "formType",
    type: "text",
  },
  {
    label: "Distribution Center",
    key: "distributionCenter",
    type: "text",
    icon: "search",
  },
  {
    label: "Store",
    key: "store",
    type: "text",
    icon: "search",
  },
  {
    label: "Dealer Number",
    key: "dealerNumber",
    type: "text",
  },
];

export const DEBI_STATUS_LIST = [
  {
    id: 1,
    label: "Incomplete DEBI Requests",
    value:"Incomplete"
  },
  {
    id: 2,
    label: "Pending DEBI Requests",
    value:"Pending"
  },
  {
    id: 3,
    label: `Open DEBI 's`,
    value:"Open"
  },
  {
    id: 4,
    label: `Cancelled DEBI 's`,
    value:"Cancelled"
  },
  {
    id: 5,
    label: "DEBI History",
  },
 

 

];
export const DOCU_SIGN_STATUS={
  COMPLETED:'completed',
  CREATED:'created',
  DECLINED:'declined',
  SENT:'sent',
  MAIL_TRIGGERED:'Mail Triggered',
  COMPLETED_VALUE:'Signed',
  CREATED_VALUE_SALES:'Waiting for DC Manager Approval',
  CREATED_VALUE_DC:'Waiting for Store Manager Approval',
  CREATED_VALUE_STORE:'Waiting for Installer Approval',
  CREATED_VALUE_INSTALLER:'Waiting for Installer Approval',
  DECLINED_VALUE:'Declined',
  SENT_VALUE:'Mail Sent',
  MAIL_TRIGGERED_VALUE:'Not Yet Signed',
}
export const DC_LIST = [
  {
    id: "",
    label : "",
  },
  {
    id: 1,
    label: "01-ALBANY",
  },
  {
    id: 2,
    label: "02-ALBUQUERQUE",
  },
  {
    id: 3,
    label: "03-ALTOONA",
  },
  {
    id: 4,
    label: "04-ATLANTA",
  },
  {
    id: 5,
    label: "08-CARLISLE",
  },
  {
    id: 6,
    label: "	09-CARROLLTON",
  },
];
export const REPORT_STATUS_LIST = [
  {
    id: 1,
    label: "DEBI Raw Data",
  },
  {
    id: 2,
    label: "Parts Summary Report",
  },
  
];
export const DEBI_REPORT_STATUS_LIST = [
  
  {
    id: 1,
    label: "Incomplete DEBI Requests",
    value:"Incomplete"
  },
 
  {
    id: 2,
    label: `Open DEBI 's`,
    value:"Open"
  },
  {
    id: 3,
    label: `Cancelled DEBI 's`,
    value:"Cancelled"
  }

];
export const ROLES_LIST = [
  {
    id: 1,
    label: "Installer",
    storeName: "Installer",
  },
  {
    id: 2,
    label: "Admin",
    storeName: "Admin"
  },
  {
    id: 3,
    label: "Store Agent",
    storeName: "Store Agent"
  },
  {
    id: 4,
    label: "DC Agent",
    storeName: "DC Agent"
  },
  {
    id: 5,
    label: "Sales Rep.",
    storeName: "Sales Rep."
  },
  
];
export const MAINTENANCE_LIST = [
  {
    control: "panel3-content",
    id: "panel3-header",
    title: "Add Parts",
    formContent: [
      {
        id: "partNumber",
        label: "Part Number",
        multiline:false,
      
      },
      {
        id: "remarks",
        label: "Remark",
        multiline:true,
        rows:4
      },
    ],
  },
];
export const MAIN_HEAD_CELLS=[
  {
    id: "debiReg",
    numeric: false,
    label: "DEBI Registration #",
  },
  {
    id: "RevNum",
    numeric: false,
    label: "Revision Number",
  },
  {
    id: "DisCenter",
    numeric: false,
    label: "Distribution Center",
  },
  {
    id: "store",
    numeric: false,
    label: "Store",
  },
  {
    id: "BName",
    numeric: false,
    label: "Installer Business Name",
  },
  {
    id: "dealerNum",
    numeric: false,
    label: "Dealer Number",
  },
  {
    id: "tel",
    numeric: false,
    label: "Telephone",
  },
  {
    id: "salesRep",
    numeric: false,
    label: "Sales Rep",
  },
  {
    id: "statusReason",
    numeric: false,
    label: "Status Reason",
  },
  {
    id: "FType",
    numeric: false,
    label: "Form Type",
  },
  {
    id: "modified",
    numeric: false,
    label: "Modified On",
  },
]
export const DC_HEAD_CELLS = [
  {
    id: "checkbox",
    numeric: false,
    label: "",
  },
  {
    id: "name",
    numeric: false,
    label: "Name",
  },
  {
    id: "city",
    numeric: false,
    label: "City",
  },
]
export const PARTS_HEAD_CELLS=[
  {
    id: "part",
    numeric: false,
    label: "Part",
  },
  {
    id: "quantity",
    numeric: false,
    label: "Quantity",
  },
  {
    id: "btn",
    numeric: false,
    label: "",
  },
]
export const PARTS_MAINTENANCE_HEAD_CELLS=[
  {
    id: "checkbox",
    numeric: false,
    label: "",
  },
  {
    id: "partNumber",
    numeric: false,
    label: "Part Number",
  },
  {
    id: "remarks",
    numeric: false,
    label: "Remark",
  },
]
export const PARTS_INSIDE_HEAD_CELLS=[
  {
    id: "checkbox",
    numeric: false,
    label: "",
  },
  {
    id: "partNumber",
    numeric: false,
    label: "Part Number",
  },
]
export const IN_PROGRESS_HEAD_CELLS=[
  {
    id: "debiReg",
    numeric: false,
    label: "DEBI Registration #",
  },
  {
    id: "DisCenter",
    numeric: false,
    label: "Distribution Center",
  },
  {
    id: "store",
    numeric: false,
    label: "Store",
  },
  {
    id: "BName",
    numeric: false,
    label: "Installer Business Name",
  },
  {
    id: "dealerNum",
    numeric: false,
    label: "Dealer Number",
  },
  {
    id: "tel",
    numeric: false,
    label: "Telephone",
  },
  {
    id: "salesRep",
    numeric: false,
    label: "Sales Rep",
  },
  {
    id: "statusReason",
    numeric: false,
    label: "Status Reason",
  },
  {
    id: "FType",
    numeric: false,
    label: "Form Type",
  },
  {
    id: "modified",
    numeric: false,
    label: "Modified On",
  },
]
export const CANCELLED_HEAD_CELLS=[
  {
    id: "debiReg",
    numeric: false,
    label: "DEBI Registration #",
  },
  {
    id: "RevNum",
    numeric: false,
    label: "Revision Number",
  },
  {
    id: "DisCenter",
    numeric: false,
    label: "Distribution Center",
  },
  {
    id: "store",
    numeric: false,
    label: "Store",
  },
  {
    id: "BName",
    numeric: false,
    label: "Installer Business Name",
  },
  {
    id: "dealerNum",
    numeric: false,
    label: "Dealer Number",
  },
  {
    id: "tel",
    numeric: false,
    label: "Telephone",
  },
  {
    id: "created",
    numeric: false,
    label: "Created On",
  },
  {
    id: "statusReason",
    numeric: false,
    label: "Status Reason",
  },
]
export const HISTORY_HEAD_CELLS= [
  {
    id: "debiReg",
    numeric: false,
    label: "DEBI Registration #",
  },
  {
    id: "RevNum",
    numeric: false,
    label: "Revision Number",
  },
  {
    id: "DisCenter",
    numeric: false,
    label: "Distribution Center",
  },
  {
    id: "store",
    numeric: false,
    label: "Store",
  },
  {
    id: "BName",
    numeric: false,
    label: "Installer Business Name",
  },
  {
    id: "dealerNum",
    numeric: false,
    label: "Dealer Number",
  },
  {
    id: "tel",
    numeric: false,
    label: "Telephone",
  },
  {
    id: "salesRep",
    numeric: false,
    label: "Sales Rep",
  },
  {
    id: "statusReason",
    numeric: false,
    label: "Status Reason",
  },
  {
    id: "FType",
    numeric: false,
    label: "Form Type",
  },
  {
    id: "modified",
    numeric: false,
    label: "Modified On",
  },
  {
    id: "status",
    numeric: false,
    label: "Status",
  },
]
export const STORE_HEAD_CELLS=[
  {
    id: "checkbox",
    numeric: false,
    label: "",
  },
  {
    id: "name",
    numeric: false,
    label: "Name",
  },
  {
    id: "storeName",
    numeric: false,
    label: "Store Name",
  },
];
